import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import { toast } from 'react-hot-toast';
import Card, {
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Button from '../../../components/bootstrap/Button';
import { api_getProductByCategory } from '../../../api/product';
import { api_makeOrder } from '../../../api/order';
import { api_getAllUsersByRole } from '../../../api/user';
import { api_getCategories } from '../../../api/category';

const animatedComponents = makeAnimated();

const AddOrder: React.FC = () => {
	const [itemId, setItemId] = useState<string>('');
	const [categories, setCategories] = useState<any[]>([]);
	const [users, setUsers] = useState<any[]>([]);
	const [items, setItems] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [orderItems, setOrderItems] = useState<any[]>([]); // State to hold order items

	useEffect(() => {
		getCategories();
		getUsers();
	}, []);

	const getCategories = async () => {
		try {
			const res = await api_getCategories();
			if (res.isSuccess) {
				setCategories(res.data);
			}
		} catch (error) {
			console.error('Error fetching categories:', error);
		}
	};

	const getUsers = async () => {
		try {
			const res = await api_getAllUsersByRole("customer");
			if (res.isSuccess) {
				setUsers(res.data);
			}
		} catch (error) {
			console.error('Error fetching users:', error);
		}
	};

	const handleCategoryChange = async (selectedCategory: any) => {
		try {
			setLoading(true);
			const res = await api_getProductByCategory(selectedCategory.value, 1, 10);
			if (res.isSuccess) {
				setItems(res.data);
			}
		} catch (error) {
			console.error('Error fetching products by category:', error);
		} finally {
			setLoading(false);
		}
	};

	const formik = useFormik({
		initialValues: {
			Quantity: '',
			phoneNumber: '', // Initial values for form fields
			dest_address: '666221abe3020b85731d9777',
		},
		onSubmit: async (values) => {
			const orderData = {
				user: users[0]?._id, // Example: Assuming you select the first user in the list
				products: orderItems.map(item => ({
					productId: item.productId,
					quantity: item.quantity,
				})),
				currency: "USD", // Hardcoded currency for example
				otherPhoneNumber: values.phoneNumber,
				dest_address: values.dest_address
			};

			try {
				const res = await api_makeOrder(orderData);
				const message = typeof res.message === 'string' ? res.message : 'Success';
				if (res.isSuccess) {
					toast.success(message);
					// Optionally navigate back after successful order
				} else {
					toast.error('Failed to create order');
				}
			} catch (error) {
				console.error('Error creating order:', error);
				toast.error('Failed to create order');
			}
		},
	});


	const handleAddItem = () => {
		const newItem = {
			productId: itemId,
			quantity: parseInt(formik.values.Quantity, 10),
		};
		setOrderItems([...orderItems, newItem]);
		setItemId('');
		formik.setFieldValue('Quantity', '');
	};

	return (
		<div className="container mt-5">
			<h1>Add New Orders</h1>
			<div className="row g-4">
				<div className="col-md-12">
					<Card className="rounded-1 mb-0">
						<CardHeader>
							<CardLabel icon="AddBusiness">
								<CardTitle>Add Items</CardTitle>
							</CardLabel>
						</CardHeader>
						<CardBody>
							<form onSubmit={formik.handleSubmit}>
								<div className="row g-3">
									<FormGroup label="Category" className="col-3">
										<Select
											options={categories.map(category => ({
												value: category._id,
												label: category.name,
											}))}
											onChange={handleCategoryChange}
										/>
									</FormGroup>

									<FormGroup label="Items" className="col-3">
										<select
											id="example"
											className="form-select"
											value={itemId}
											onChange={(e) => setItemId(e.target.value)}
										>
											<option value="" disabled>
												Select an item...
											</option>
											{items.map((item: any, index: number) => (
												<option key={index} value={item._id}>
													{item.name}
												</option>
											))}
										</select>
									</FormGroup>

									<FormGroup label="Quantity" className="col-3">
										<Input
											type="number"
											id="Quantity"
											name="Quantity"
											min={0}
											onChange={formik.handleChange}
											value={formik.values.Quantity}
										/>
									</FormGroup>

									<FormGroup className="col-3">
										<Button
											type="button"
											color="primary"
											onClick={handleAddItem}
										// disabled={!itemId || !formik.values.Quantity}
										>
											Add Item
										</Button>
									</FormGroup>

									{/* Display added items */}
									{orderItems.map((item, index) => (
										<div key={index} className="row g-3 mt-2">
											<FormGroup label="Product: " className="col-3">
												<span>{items.find(i => i._id === item.productId)?.name}</span>
											</FormGroup>
											<FormGroup label="Quantity: " className="col-3">
												<span>{item.quantity}</span>
											</FormGroup>
										</div>
									))}

									<FormGroup label="Customer" className="col-10">
										<Select
											options={users.map(user => ({
												value: user._id,
												label: user.name,
												phoneNumber: user.phoneNumber, // Include phoneNumber and dest_address in options
												dest_address: user.dest_address,
											}))}
											onChange={(selectedOption) => {
												formik.setFieldValue('phoneNumber', selectedOption?.phoneNumber || '');
												formik.setFieldValue('dest_address', selectedOption?.dest_address || '');
											}}
										/>
									</FormGroup>

									<FormGroup label="Active Phone Number" className="col-4">
										<Input
											type="text"
											id="phoneNumber"
											name="phoneNumber"
											onChange={formik.handleChange}
											value={formik.values.phoneNumber}
										/>
									</FormGroup>

									<FormGroup label="Destination Address" className="col-6">
										<Input
											type="text"
											id="dest_address"
											name="dest_address"
											onChange={formik.handleChange}
											value={formik.values.dest_address}
										/>
									</FormGroup>

								</div>
								<Button
									type="submit"
									color="info"
									className="mt-4"
									style={{ width: '200px' }}
								>
									Confirm Order
								</Button>
							</form>
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	);
};

export default AddOrder;
